import http from '@/utils/request'

export const save = data =>
  http({
    url: `contact/front/save`,
    method: 'post',
    data
  })